import React, { useState } from "react";
import Loader from "../components/Loader"; // Import Loader component

const APIStats = () => {
  const [loading, setLoading] = useState(true); // State to track iframe loading

  return (
    <div style={{ height: "100vh", width: "85vw", margin: 0, padding: 0 }}>
      {loading && (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
          <Loader message="Loading API Stats..." /> {/* Show loader while iframe is loading */}
        </div>
      )}
      <iframe
        src="https://utilities.livauto.com/#/all-stats/1706a45d-fed2-401b-a1d5-ab2f48670181"
        title="API Stats"
        style={{
          height: "100%",
          width: "100%",
          border: "none",
          display: loading ? "none" : "block", // Hide iframe until it loads
        }}
        onLoad={() => setLoading(false)} // Hide loader when iframe loads
      ></iframe>
    </div>
  );
};

export default APIStats;
